export const fetchBankStatementTransactionsQuery = () => {
    const query = `
    query($file: Upload){
        getBankStatementTransactions(
            bankStatementFile: $file, 
        ){
          date 
          uniqueRowId
          transactionId
          moneyIn
          transactionType 
          moneyOut
          phoneNumbers
          tenant{
            tenantId
            firstName
            lastName
            unitId
            propertyId
            archived
            accountBalance
          }
          duplicatePayment{
            id 
            bankTransactionId
            amount 
            tenantDetails{
              tenantId
              firstName
              lastName
              unitId
              propertyId
              archived
              accountBalance
            }
          }
          transactionDetails
        }
      }
    `;
    return query;
}

export const saveBankStatementTransactionsMutation = (transactions) => {
    let formattedTransactions = [];
    let tenantStr;
    for(let trans of transactions){
        tenantStr = "";
        if(trans["tenantId"]){
            tenantStr = ` tenantId: ${JSON.stringify(trans["tenantId"])},`
        }
        formattedTransactions.push(
            `{ date: "${trans["date"]}", transactionId: "${trans["transactionId"]}", moneyIn: ${trans["moneyIn"]}, ${tenantStr} extraDetailsJson: ${trans["extraDetailsJson"]} } `
        );
    }
    const mutation = `
        mutation{
            saveBankStatement(transactions:[ ${formattedTransactions.join(", ")} ]){
            errorMessage
            payments{
                id
                tenantDetails{
                    tenantId
                    firstName
                    lastName
                    unitId
                    propertyId
                    archived
                }
                amount
                paymentType
                description
                createdTs
                paymentDate
                status
                lastUpdated
                status
                bankTransactionId
                recordedBy{
                    id
                }
                totalInvoiced
                creditNote
                upload{
                    id
                    file
                }
                message{
                    id
                    message
                }
            }
        }
        }
    `;
    return mutation;
}